import { useTranslation } from "react-i18next";

import iconStarSelected from "assets/icons/star-selected.svg";
import iconStarUnselected from "assets/icons/star-unselected.svg";
import _ from "lodash";
import moment from "moment-timezone";

import ModalsService from "services/modals-service";

import { EModals } from "types/enums";

import { resolveFileUrl } from "constants/config";
import styled from "styled-components";
import React from "react";

type ReviewsSectionProps = {
    reviews: any[];
};

const ReviewsSection = (props: ReviewsSectionProps) => {
    const { reviews } = props;

    const reviewsToShow = reviews.filter(i => i.published);

    const { t } = useTranslation();

    const averageRating = (reviewsToShow.map((i) => i.rating).reduce((a, b) => a + b, 0) / (reviewsToShow.length || 1)).toFixed(1);

    console.log('render! reviewsToShow = ', reviewsToShow);

    let sortedReviews = reviewsToShow.sort((a, b) => {
        let scoreA = (+a.timestamp + (a.isAmbassador == true ? 10000000000 : 0));
        let scoreB = (+b.timestamp + (b.isAmbassador == true ? 10000000000 : 0));
        if (a.isVip == true) {
            scoreA += 400000000;
        }
        if (b.isVip == true) {
            scoreB += 400000000;
        }
        return -(scoreA - scoreB);
    });

    console.log('sortedReviews = ', sortedReviews);

    return (
        <>
            {sortedReviews.length > 0 && (
                <div className="flex flex-col w-full gap-4">
                    <div className="flex flex-row w-full justify-between">
                        <h2>{t("0lhhbuxgbpeg")}</h2>
                        <div className="flex flex-row gap-2 items-center justify-center">
                            <img alt="Star" src={iconStarSelected} className="w-10 h-10" />
                            <span>{averageRating}</span>
                        </div>
                    </div>
                    {sortedReviews.map((review) => (
                        <div key={review.id} className="flex flex-col border-2 border-neutral-300 px-12 py-6 rounded-lg">
                            <div className="flex flex-row w-full justify-between">
                                <span>

                                    <span style={{fontWeight: 'bold', fontSize: '20px'}} >
                                        {_.get(review, "topic", "")}

                                        {review.isAmbassador == false ? null :
                                            <BadgeSpan style={{ marginLeft: 10 }}>
                                                {`${review.isVip == true ? 'почётный ' : ' '}амбассадор`}
                                            </BadgeSpan>
                                        }

                                    </span>
                                    <br/>
                                    <span>
                                        {_.get(review, "text", "")}
                                    </span>
                                    {(_.get(review, "uniComment", "") == undefined || _.get(review, "uniComment", "") == '') ? null :
                                        <>
                                            <br/>
                                            <div className={'text-italic italic text-sm text-gray-400'} >
                                                {_.get(review, "uniComment", "")}
                                            </div>
                                        </>
                                    }
                                </span>
                                <span>{moment(_.get(review, "timestamp", 0)).format("DD.MM.YYYY")}</span>
                            </div>
                            <div className="flex flex-row w-full gap-4 mt-4">
                                {_.get(review, "photos", []).map((photo) => (
                                    <div
                                        key={photo}
                                        className="flex flex-col items-center justify-center w-24 h-24 rounded-lg border-2 border-neutral-300"
                                        onClick={() =>
                                            ModalsService.showModal(EModals.OverlayedGallery, {
                                                photos: _.get(review, "photos", []),
                                                currentPhotoNumber: 0,
                                            })
                                        }
                                    >
                                        <img alt="Users data" src={resolveFileUrl(photo)} className="w-24 h-24 rounded-lg object-cover" />
                                    </div>
                                ))}
                            </div>
                            <span className="text-slate-600 font-semibold">{_.get(review, "userName", "")}</span>
                            <div className="flex flex-row gap-1 items-center justify-center w-fit">
                                {new Array(5).fill(0).map((_, i) => (
                                    <img
                                        alt="Star"
                                        src={i < (review || {})?.rating || 0 ? iconStarSelected : iconStarUnselected}
                                        className="w-4 h-4"
                                    />
                                ))}
                                <span className="ml-2">{_.get(review, "rating", 0)}</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default ReviewsSection;

const BadgeSpan = styled.span`
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  height: 24px;
  line-height: 24px;
  color: rgb(21, 128, 61);
  background-color: rgb(220, 252, 231);
  border-radius: 1000px;
  font-size: 12px;
  alignment: right;
  //opacity: 0.6;
`;